import React, { Suspense } from "react";
import { useParams } from "react-router-dom";

export default function DynamicSutraLoader({ sutraComponents }) {
  const { level, chapter, game } = useParams();

  const DynamicComponent = sutraComponents?.[level]?.[chapter]?.[game];

  if (!DynamicComponent) {
    return <div>Component not found</div>;
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <DynamicComponent />
    </Suspense>
  );
}
